import { Form, message, Input, Radio, Checkbox, Select } from "antd";
import axios from "axios";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import MiniFormDrawer from "../../components/mini-form-drawer";
import ActionButton from "../../components/action-button";
import InputName from "../../components/input-name";
import { Modulos } from "../../constants";
import styles from "./_styles.less";
import InputAnexo from "../../components/input-anexo";
import unwrapAxiosPromise from "../../util/unwrapAxiosPromise";

const defaultValue = {
  nome: "",
  descricao: "",
};

export default function ModeloDrawer({ loading, onAfterClose, onChange, onClose, value = defaultValue, visible, personalizado }) {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [loadingSave, setLoadingSave] = useState(false);
  const [tagOptions, setTagOptions] = useState([]);

  const fireChange = () => typeof onChange === "function" && onChange();
  const fireClose = () => {
    form.resetFields();
    if (typeof onClose === "function") onClose();
  };

  useEffect(() => {
    form.setFieldsValue(value);
  }, [value]);

  const modulosOptions = Modulos.filter((tab) => ["compliance", "societario"].includes(tab.id)).map((tab) => ({
    label: t(tab.label),
    value: tab.id,
  }));

  const handleFinish = (values) => {
    setLoadingSave(true);

    const formData = new FormData();
    formData.append("nome", values.nome || "");
    formData.append("descricao", values.descricao || "");
    formData.append("modulo", values.modulo || "");
    formData.append("tags", values.tags || "");
    formData.append("personalizado", personalizado);

    const anexo = values.anexo;
    if (anexo instanceof File || anexo instanceof Blob) {
      formData.append("anexo", anexo);
    }

    const request = value.id
      ? axios.put(`/modelos/${value.id}`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
      : axios.post("/modelos", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

    unwrapAxiosPromise(request, form)
      .then(() => {
        message.success(t(value.id ? "Alterado com sucesso" : "Criado com sucesso"));
        form.resetFields();
        fireChange();
        fireClose();
      })
      .finally(() => setLoadingSave(false));
  };

  const footer = (
    <>
      <ActionButton.Save onClick={() => form.submit()} loading={loadingSave} />
      <ActionButton.Close onClick={fireClose} disabled={loadingSave} />
    </>
  );

  const drawerTitle = value.id ? `${value.nome}` : t("Criar Modelo");

  return (
    <MiniFormDrawer drawerTitle={drawerTitle} drawerFooter={footer} drawerWidth={500} drawerVisible={visible} form={form} loading={loading} onDrawerClose={fireClose} onDrawerAfterClose={onAfterClose} onFinish={handleFinish}>
      <Form.Item name="nome" label={t("Nome")}>
        <InputName disabled={loadingSave} />
      </Form.Item>
      <Form.Item name="modulo" label={t("Módulo")}>
        <Select
          disabled={loadingSave}
          placeholder={t("Selecione o módulo")}
          options={modulosOptions}
          onChange={(value) => {
            if (value === "societario") {
              setTagOptions([
                { label: "Procuradores", value: "procuradores" },
                { label: "Contratos", value: "contratos" },
              ]);
            } else if (value === "compliance") {
              setTagOptions([{ label: "Documentos", value: "documentos" }]);
            } else {
              setTagOptions([]);
            }
          }}
        />
      </Form.Item>
      <Form.Item name="tags" label={t("Tipo de modelo")}>
        <Select disabled={loadingSave} placeholder={t("Selecione a tag")} options={tagOptions} />
      </Form.Item>

      <Form.Item name="descricao" label={t("Descrição")}>
        <Input.TextArea rows={4} disabled={loadingSave} />
      </Form.Item>
      <Form.Item name="anexo" label={t("Anexo")}>
        <InputAnexo disabled={loading} accept=".docx" />
      </Form.Item>
    </MiniFormDrawer>
  );
}

ModeloDrawer.propTypes = {
  loading: PropTypes.bool,
  onAfterClose: PropTypes.func,
  onChange: PropTypes.func,
  onClose: PropTypes.func,
  value: PropTypes.object,
  visible: PropTypes.bool,
};
